<!-- LOADING STATE -->
@if (loading) {
  <div class="container py-5 text-center">
    <div class="spinner-border text-success" role="status">
      <span class="visually-hidden">{{ 'COMMON.loading' | translate }}</span>
    </div>
  </div>
}

<!-- NOT FOUND STATE -->
@else if (!newsItem) {
  <div class="container py-5 text-center">
    <p class="text-muted">الخبر غير موجود.</p>
    <a routerLink="/news" class="btn btn-outline-secondary mt-3">العودة للأخبار</a>
  </div>
}

<!-- MAIN CONTENT -->
@else {
  <div class="page__header">
    <div class="container">
      <div class="row">
        <div class="col-12 col-lg-12">
          <div class="d-flex align-items-center breadCrumb-wrapper-details">
            <div class="item">
              <p class="bread__name" routerLink="/home">
                {{ 'Nav.Home' | translate }}
              </p>
            </div>
            <div class="item">
              <span>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M15 18l-6-6 6-6"/>
                </svg>
              </span>
              <p class="bread__name" routerLink="/news">
                {{ translate.currentLang === 'en' ? 'Quranic Sciences in Musahifs' : 'علوم القرآن في المصاحف' }}
              </p>
            </div>
            <div class="item">
              <span>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M15 18l-6-6 6-6"/>
                </svg>
              </span>
              <p class="bread__name">
                {{ translate.currentLang === 'en' ? newsItem.titleEN : newsItem.titleAR }}
              </p>
            </div>
          </div>
          <div class="page__header__text">
            <h2 class="page__header__title">
              {{ translate.currentLang === 'en' ? newsItem.titleEN : newsItem.titleAR }}
            </h2>
            <div class="extra__info">
              <div class="extra__info__item">
                <div class="icon">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                    <line x1="16" y1="2" x2="16" y2="6"></line>
                    <line x1="8" y1="2" x2="8" y2="6"></line>
                    <line x1="3" y1="10" x2="21" y2="10"></line>
                  </svg>
                </div>
                {{ newsItem.createdAt }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="container">
    <div class="news__details">
      <div class="news__details__content">
        <div class="news__details__poster">
          <img
            [src]="getFileUrl(newsItem.imageUrl)"
            [alt]="translate.currentLang === 'en' ? newsItem.titleEN : newsItem.titleAR"
            onerror="this.src='/media/images/custom/defualt-img.jpg'"
          />
        </div>
        <div
          class="news__details__description text__editor description__text"
          [innerHtml]="translate.currentLang === 'en'
            ? sanitizeHtml(newsItem.descriptionEN)
            : sanitizeHtml(newsItem.descriptionAR)"
        ></div>
      </div>
    </div>
  </div>
}

<!-- Starts : Footer -->
<app-footer></app-footer>
<!-- Ends : Footer -->
